import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataStorageService } from '../shared/data-storage.service';
import { environment } from 'src/environments/environment.prod';
@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {
  constructor(private router: Router, private dataStorageService: DataStorageService) { }
  data: string;
  ngOnInit(): void {
    this.data = sessionStorage.getItem('id');
    if (this.data != null && this.data != "abc") {
      // this.data = "";
      //sessionStorage.setItem('id', "abc")
      //sessionStorage.setItem('id', "")
      this.data = sessionStorage.getItem('id')
      this.dataStorageService.onVerifyDisposeSession(this.data).subscribe(resData => {
        //console.log("Dispose_Session_data " + resData.disposeSession);
        sessionStorage.setItem('id', "abc")
        this.router.navigate(['landing']);
      })
      sessionStorage.setItem('id', "abc")
      //console.log("data "+this.data);
      this.router.navigate(['landing']);
      //}
    }
  }
}
